import {Component, ElementRef, HostListener, Injectable, Input, OnDestroy, OnInit} from '@angular/core';
import {FlatTreeControl} from '@angular/cdk/tree';
import {MatTreeFlatDataSource, MatTreeFlattener} from '@angular/material/tree';
import {BehaviorSubject, Observable, of as observableOf, Subject} from 'rxjs';
import {CdkDragDrop} from '@angular/cdk/drag-drop';
import {FlowChartNode, FlowChartUiFlatNode} from '../../../models/data-survey.models';
import {FlowChartDataService} from '../../../services/flow-chart-data.service';
import {DialogModel} from '@shared/models/dialog.model';
import {DialogService} from '@shared/services/dialog-service';
import {CommandService} from '@core/services/command.service';
import {HttpClient} from '@angular/common/http';
import {skip, take, takeUntil} from 'rxjs/operators';
import {SmartGridService} from '@core/services/smart-grid.service';
import {Configuration} from '@shared/models/configuration';
import {SnackBarService} from '@core/services/snack-bar.service';
import { FuseSplashScreenService } from '@barebone-fuse-services/splash-screen.service';
import { FuseSidebarService } from '@barebone-fuse/@fuse/components/sidebar/sidebar.service';
import {ParticleCacheService} from '@core/services/particle-cache.service';
import {EntityFields} from '../../../../dac6-reporter/Fields';
import {UpdateSurveyDataItemCommand} from '../../../commands/survey.commands';
import {QueryProvider} from '@shared/queries/query-provider';
import {select, Store} from '@ngrx/store';
import {IQueryState} from '@shared/store/reducers/query.reducer';
import {getQueryResponse} from '@shared/store/selectors/query.selector';
import {CreateChatConversationCommand} from '../../../../task-manager/collaboration/store/collaboration.command';
import {ContentScope} from '@shared/commands/command-base';
import {CreateChatConversationAction} from '../../../../task-manager/collaboration/store/collaboration.action';
import {ConversationComponentName} from '../../../../task-manager/collaboration/store/collaboration.constants';
import {CollaborationState} from '../../../../task-manager/collaboration/store/collaboration.reducer';
import {ApplyHallmarkTagCommand} from '../../../../dac6-reporter/commands/dac6-reporter.command';
import {HallmarkTaggingService} from '@core/services/hallmark-tagging.service';
import {
  SetCurrentRightSideBarFoldOrNotAction,
  SetCurrentRightSideComponentAction,
  SetCurrentViewDetailAction
} from '@shared/components/platform-sidebar/store/platform-sidebar.action';
import {PlatformSidebarState} from '@shared/components/platform-sidebar/store/platform-sidebar.reducer';
import {DetailsInstructionService, InstructionDetailsSourceViewType} from '@shared/services/details-instruction-service';


@Component({
    standalone: false,
    selector: 'particle-flow-chart-response',
  templateUrl: './flow-chart-response.component.html',
  styleUrls: ['./flow-chart-response.component.scss'],
})
export class FlowChartResponseComponent implements OnInit, OnDestroy {
  constructor(private snackBarService: SnackBarService,
              private fuseSplashScreenService: FuseSplashScreenService,
              private smartGridService: SmartGridService,
              private  flowChartDataService: FlowChartDataService,
              private dialogService: DialogService,
              private commandService: CommandService,
              private particleCacheService: ParticleCacheService,
              private eRef: ElementRef,
              public queryState: Store<IQueryState>,
              private collaborationStore: Store<CollaborationState>,
              private hallmarkTaggingService: HallmarkTaggingService,
              private platformSidebarStore: Store<PlatformSidebarState>,
              private sidebarService: FuseSidebarService,
              protected detailsInstructionService: DetailsInstructionService
  ) {
    this.treeFlattener = new MatTreeFlattener(this.transformer, this._getLevel,
      this._isExpandable, this._getChildren);
    this.treeControl = new FlatTreeControl<FlowChartUiFlatNode>(this._getLevel, this._isExpandable);
    this.dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);
    this.dataChange.pipe(takeUntil(this.unsubscribe$)).subscribe(data => this.rebuildTreeForData(data));
  }

  get data(): FlowChartNode[] {
    return this.dataChange.value;
  }

  treeControl: FlatTreeControl<FlowChartUiFlatNode>;
  treeFlattener: MatTreeFlattener<FlowChartNode, FlowChartUiFlatNode>;
  dataSource: MatTreeFlatDataSource<FlowChartNode, FlowChartUiFlatNode>;
  expandedNodeSet = new Set<string>();
  dragging = false;
  expandTimeout: any;
  expandDelay = 1000;

  selectedNodeId: string = '';
  @Input() section: any;
  @Input() surveyId: string;
  @Input() sourceType: string;
  @Input() rowItem: any;
  @Input() fieldDefinitions: any;
  hasTagsMapping: any = {};
  unsubscribe$ = new Subject<void>();
  /** SHAON */
  /** Map from flat node to nested node. This helps us finding the nested node to be modified */
  flatNodeMap = new Map<FlowChartUiFlatNode, FlowChartNode>();

  /** Map from nested node to flattened node. This helps us to keep the same object for selection */
  nestedNodeMap = new Map<FlowChartNode, FlowChartUiFlatNode>();
  /** SHAON */

    ////////////////////////////////////// TreeBuild//////////////////////////
  dataChange = new BehaviorSubject<FlowChartNode[]>([]);

  ngOnDestroy() {
    this.flowChartDataService.destroy();
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  /** SHAON */

  transformer = (node: FlowChartNode, level: number) => {
    // return new FileFlatNode(!!node.children, node.filename, level, node.type, node.id);

    /** SHAON */
    const existingNode = this.nestedNodeMap.get(node);
    const flatNode = new FlowChartUiFlatNode(!!node.children, level, node.id, node);
    flatNode.level = level;
    flatNode.expandable = !!node.children;
    this.flatNodeMap.set(flatNode, node);
    this.nestedNodeMap.set(node, flatNode);
    return flatNode;
    /** SHAON */
  }
  private _getLevel = (node: FlowChartUiFlatNode) => node.level;
  private _isExpandable = (node: FlowChartUiFlatNode) => node.expandable;
  private _getChildren = (node: FlowChartNode): Observable<FlowChartNode[]> => observableOf(node.children);
  hasChild = (_: number, _nodeData: FlowChartUiFlatNode) => _nodeData.item.children.length > 0;


  /**
   * This constructs an array of nodes that matches the DOM,
   * and calls rememberExpandedTreeNodes to persist expand state
   */
  visibleNodes(): FlowChartNode[] {
    this.rememberExpandedTreeNodes(this.treeControl, this.expandedNodeSet);
    const result = [];

    function addExpandedChildren(node: FlowChartNode, expanded: Set<string>) {
      result.push(node);
      if (expanded.has(node.id)) {
        node.children.map(child => addExpandedChildren(child, expanded));
      }
    }

    this.dataSource.data.forEach(node => {
      addExpandedChildren(node, this.expandedNodeSet);
    });
    return result;
  }

  /**
   * The following methods are for persisting the tree expand state
   * after being rebuilt
   */

  rebuildTreeForData(data: any) {
    this.rememberExpandedTreeNodes(this.treeControl, this.expandedNodeSet);
    this.dataSource.data = data;
    this.forgetMissingExpandedNodes(this.treeControl, this.expandedNodeSet);
    this.expandNodesById(this.treeControl.dataNodes, Array.from(this.expandedNodeSet));
    this.expandAllNodes();
  }

  private rememberExpandedTreeNodes(
    treeControl: FlatTreeControl<FlowChartUiFlatNode>,
    expandedNodeSet: Set<string>
  ) {
    if (treeControl.dataNodes) {
      treeControl.dataNodes.forEach((node) => {
        if (treeControl.isExpandable(node) && treeControl.isExpanded(node)) {
          // capture latest expanded state
          expandedNodeSet.add(node.id);
        }
      });
    }
  }

  private forgetMissingExpandedNodes(
    treeControl: FlatTreeControl<FlowChartUiFlatNode>,
    expandedNodeSet: Set<string>
  ) {
    if (treeControl.dataNodes) {
      expandedNodeSet.forEach((nodeId) => {
        // maintain expanded node state
        if (!treeControl.dataNodes.find((n) => n.id === nodeId)) {
          // if the tree doesn't have the previous node, remove it from the expanded list
          expandedNodeSet.delete(nodeId);
        }
      });
    }
  }

  private expandNodesById(flatNodes: FlowChartUiFlatNode[], ids: string[]) {
    if (!flatNodes || flatNodes.length === 0) {
      return;
    }
    const idSet = new Set(ids);
    return flatNodes.forEach((node) => {
      if (idSet.has(node.id)) {
        this.treeControl.expand(node);
        let parent = this.getParentNode(node);
        while (parent) {
          this.treeControl.expand(parent);
          parent = this.getParentNode(parent);
        }
      }
    });
  }

  private expandAllNodes() {
    this.treeControl.dataNodes.forEach((node) => {
      this.treeControl.expand(node);
      let parent = this.getParentNode(node);
      while (parent) {
        this.treeControl.expand(parent);
        parent = this.getParentNode(parent);
      }
    });
  }

  private getParentNode(node: FlowChartUiFlatNode): FlowChartUiFlatNode | null {
    const currentLevel = node.level;
    if (currentLevel < 1) {
      return null;
    }
    const startIndex = this.treeControl.dataNodes.indexOf(node) - 1;
    for (let i = startIndex; i >= 0; i--) {
      const currentNode = this.treeControl.dataNodes[i];
      if (currentNode.level < currentLevel) {
        return currentNode;
      }
    }
    return null;
  }

  ngOnInit(): void {
    this.initialize();
    // It should be from serverside. Urgent Release fix.
    this.setDisplayTextOfAttachments(this.fieldDefinitions, this.rowItem);
    this.queryState.pipe(select(getQueryResponse, 'SurveyDetailViewResponse'), skip(1)).subscribe(state => {
      if (state && state.item && this.rowItem && this.rowItem.id === state.item.id) {
        this.rowItem = state.item;
        this.flowChartDataService.fieldVisibilities = state.fieldVisibilities;
        this.setDisplayTextOfAttachments(this.fieldDefinitions, this.rowItem);
        this.initialize();
      }
    });
    if (this.fieldDefinitions) {
      Object.keys(this.fieldDefinitions).forEach((x: any) => {
        this.hasTagsMapping[x] = {};
        this.hasTagsMapping[x].hasApplyHallmarkTags = this.hasApplyHallmarkTags(this.fieldDefinitions[x]);
        this.hasTagsMapping[x].hasHallmarkShowTags = this.hasHallmarkShowTags(this.fieldDefinitions[x]);
        this.hasTagsMapping[x].hasFieldDetais = this.hasFieldDetais(this.fieldDefinitions[x].key);
      });
    }
  }

  /** SHAON */
  hasNoContent = (_: number, _nodeData: FlowChartUiFlatNode) => _nodeData.item.title === '';

  onSelectedNode(node: any) {
    this.selectedNodeId = node.item.id;
    this.openDetailsAndInstructions(node);
  }


  initialize() {
    // Parse the string to json object.
    const dataObject = this.section.questions.filter(q => !this.flowChartDataService.fieldVisibilities || this.flowChartDataService.fieldVisibilities[q.fieldKey]); // JSON.parse(this.TREE);

    // Build the tree nodes from Json object. The result is a list of `Node` with nested
    //     file node as children.
    const data = this.buildTree(dataObject, 0);

    // Notify the change.
    this.dataChange.next(data);
  }

  /**
   * Build the file structure tree. The `value` is the Json object, or a sub-tree of a Json object.
   * The return value is the list of `Node`.
   */
  /** SHAON */
  buildTree(tree: FlowChartNode[], level: number, parentId: string = '0'): FlowChartNode[] {
    return tree.reduce<FlowChartNode[]>((accumulator, obj, idx) => {
      const node = {...obj} as FlowChartNode;

      /**
       * Make sure your node has an id so we can properly rearrange the tree during drag'n'drop.
       * By passing parentId to buildFileTree, it constructs a path of indexes which make
       * it possible find the exact sub-array that the node was grabbed from when dropped.
       */
      node.copyId = node.id;
      node.sourceSectionId = this.section.id;

      // node.id = `${parseInt(parentId)+1}:${idx+1}`;


      if (obj != null) {
        if (typeof obj === 'object') {
          const children = obj.children.filter((q: any) => !this.flowChartDataService.fieldVisibilities || this.flowChartDataService.fieldVisibilities[q.fieldKey]);
          node.children = this.buildTree(children, level + 1, node.id);
        } else {
          console.log('not a object in tree node');
        }
      }

      return accumulator.concat(node);
    }, []);
  }

  /** SHAON */

  ////////////////// all api call///////////
  onEdit(node: any) {
    if (!node.item.isHidden && this.fieldDefinitions[node.item.fieldKey] && this.fieldDefinitions[node.item.fieldKey].isReadOnly === true) {
      return;
    }

    const minWidth = '600px';
    const maxWidth = '600px';
    this.dialogService.showCellEditorDialog(this.rowItem, this.fieldDefinitions[node.item.fieldKey], minWidth, maxWidth, this.sourceType).pipe(takeUntil(this.unsubscribe$)).subscribe(state => {
      console.log('After Edit', state);

      if (state.action === 'OK') {
        console.log('After Edit', state);
        if (!this.shouldContinueProcessing(node)) {
          return;
        }
        const executionSourceType = this.rowItem.cells['ExecutionSourceType'].value;
        const executionId = this.rowItem.cells['ExecutionId'].value;
        const item = {id: this.rowItem.id, fieldValues: {}, executionId: executionId};
        const value = this.rowItem.cells[node.item.fieldKey].value;
        item.fieldValues[node.item.fieldKey] = value;
        this.fuseSplashScreenService.show();
        const command = new UpdateSurveyDataItemCommand(item, this.surveyId, executionId, executionSourceType, null);
        this.commandService.executeCommand(command).pipe(takeUntil(this.unsubscribe$)).subscribe(commandState => {
            console.log('Command State', commandState);
            this.fuseSplashScreenService.hide();
            QueryProvider.invokeQuery(this.queryState, 'SurveyDetailViewResponse', {
                '[SurveyId]': this.surveyId,
                '[ItemId]': this.rowItem.id
              }
            );
          },
          error => {
            this.fuseSplashScreenService.hide();
            console.error('UpdateSurveyDataItemCommand error ', error);
          }
        );
      }
    });
  }

  private shouldContinueProcessing(node: any) {
    switch (node.item.fieldKey) {
      case 'Suggested_Hallmarks':
        return false;
      default:
        return true;
    }
  }

  openConversationForThisField(key) {
    const fieldDefinition = this.fieldDefinitions[key.item.fieldKey];
    let formTitle = '';
    let formId = null;
    let sourceInfoDictionary: any;
    let chatTitle: any;
    let sourceType: any;
    let fieldKeyDuplicate = fieldDefinition.key; // build fix. duplicate key
    if (this.rowItem.cells['CaseGUID'] && this.rowItem.cells['CaseGUID'].displayText) {
      let chatType = 'Form';
      formId = this.rowItem.cells['CaseGUID'].displayText;
      if (this.rowItem.cells['TYPE'] && this.rowItem.cells['TYPE'].value) {
        chatType = this.rowItem.cells['TYPE'].value;
      }
      if (this.rowItem.cells['Title'] && this.rowItem.cells['Title'].displayText) {
        formTitle = this.rowItem.cells['Title'].displayText;
      }
      if (this.rowItem.cells['FormTitle'] && this.rowItem.cells['FormTitle'].displayText) {
        formTitle = this.rowItem.cells['FormTitle'].displayText;
      }

      let relativeUrl = `dac6-reporter/filing-manager/forms/${formId}`;
      if (chatType !== 'Form') {
        relativeUrl = `dac6-reporter/overview/case/${formId}`;
      }
      sourceType = 'DAC6Form';
      const sourceTitle = `${this.rowItem.cells['CaseId'].displayText}-${formTitle}`;
      chatTitle = `${this.rowItem.cells['CaseId'].displayText}-${fieldDefinition.header}`;
      sourceInfoDictionary = {
        'sourceInfoDictionary': {
          formId: `${formId}`,
          fieldKey: `${fieldKeyDuplicate}`,
          relativeUrl: `${relativeUrl}`,
          sourceTitle: `${sourceTitle}`
        }
      };
    } else {
      formId = this.rowItem.id;
      sourceType = 'CellEditor';
      chatTitle = fieldDefinition.header;
      sourceInfoDictionary = {
        'sourceInfoDictionary': {
          itemId: `${formId}`,
          fieldKey: `${fieldKeyDuplicate}`,
          relativeUrl: '',
          sourceTitle: ''
        }
      };
    }
    if (!formId || !fieldKeyDuplicate) {
      return;
    }
    const createChatConversationCommand = new CreateChatConversationCommand(
      '[COMPANY_ID]-chat',
      chatTitle,
      true,
      0,
      sourceType,
      [],
      true,
      ``,
      sourceInfoDictionary
    );
    createChatConversationCommand.scope = ContentScope.Company;
    this.collaborationStore.dispatch(new CreateChatConversationAction(createChatConversationCommand, ConversationComponentName));
  }

  hasFieldDetais(fieldKey) {
    let fieldDetailId = `${this.sourceType}-${fieldKey}`;
    if (this.rowItem.cells['ViewDetailsType']) {
      fieldDetailId = `${this.rowItem.cells['ViewDetailsType'].value}-${fieldKey}`;
    }
    fieldDetailId = fieldDetailId.toLowerCase();
    const fieldDetail = this.particleCacheService.getItem(fieldDetailId);
    if (fieldDetail && (fieldDetail.version === this.particleCacheService.getClientConfigVersion())) {
      return true;
    } else {
      return false;
    }
  }

  hasHallmarkShowTags(fieldDef) {
    return (fieldDef.metaData && fieldDef.metaData.HallmarkKeywordId && fieldDef.metaData.HallmarkKeywordId != null);
  }

  hasApplyHallmarkTags(fieldDef) {
    return (fieldDef.metaData && fieldDef.metaData.ApplyHallmarkTagsKey && fieldDef.metaData.ApplyHallmarkTagsKey != null);
  }

  openDetailsPopUp(node: FlowChartUiFlatNode) {
    const header = '<div style="margin-bottom: 20px;font-weight: bold;font-size: .95rem;">' + node.item.title + '</div>';
    const fieldKey = node.item.fieldKey;
    let fieldDetailId = `${this.sourceType}-${fieldKey}`;
    if (this.rowItem.cells['ViewDetailsType']) {
      fieldDetailId = `${this.rowItem.cells['ViewDetailsType'].value}-${fieldKey}`;
    }
    fieldDetailId = fieldDetailId.toLowerCase();

    const details = this.particleCacheService.getItem(fieldDetailId);
    const dialogModel: DialogModel = DialogModel.create(
      'Details',
      'ViewDetailsComponent',
      {
        viewDetails: details.value.Details
      },
      '600px',
      '700px'
    );
    dialogModel.okCaption = '';
    dialogModel.cancelCaption = '';
    this.platformSidebarStore.dispatch(
      new SetCurrentRightSideComponentAction(
        {component: 'ViewDetailComponent', data: {isUserAction: true}, componentInfo: {id: 'ViewDetailComponent'}}));
    const ViewDetailObj = header + details.value.Details;
    this.platformSidebarStore.dispatch(new SetCurrentViewDetailAction(ViewDetailObj));
    /*this.dialogService.showOkCancelDialog(dialogModel).pipe(takeUntil(this.unsubscribe$)).subscribe(res => {
      // console.log(res);
    });*/
  }

  openHallmarkShowTagsPopUp(node: FlowChartUiFlatNode) {
    const fieldDef = this.fieldDefinitions[node.item.fieldKey];
    this.hallmarkTaggingService.openHallmarkTaggingDialog(fieldDef.metaData.HallmarkKeywordId);
  }

  openApplyHallmarkTagsPopUp(node: FlowChartUiFlatNode) {
    const selectedTags = (this.rowItem.cells.ApplyTags != null) ? this.rowItem.cells.ApplyTags.value : [];
    const dialogueModel = DialogModel.create('Apply Hallmark Tags', 'ApplyHallmarkTaggingDialogComponent', {selectedTags: selectedTags});
    dialogueModel.maxWidth = '490px';
    dialogueModel.minWidth = '490px';
    this.dialogService.showOkCancelDialog(dialogueModel).subscribe(res => {
      if (res.action === 'OK') {
        const modelType = this.sourceType === 'PreArrangement' ? 'prearrangementmodel' : 'arrangementmodel';
        const apiKey = this.flowChartDataService.getApi();
        const command = new ApplyHallmarkTagCommand(this.rowItem.id, res.data.input.selectedTags, modelType, apiKey);

        this.commandService.executeCommand(command).subscribe(state => {
          if (state.Payload === 'Apply Tags Success') {
            // this.valueChanged.emit({action: 'Refresh'});
            QueryProvider.invokeQuery(this.queryState, 'SurveyDetailViewResponse', {
                '[SurveyId]': this.surveyId,
                '[ItemId]': this.rowItem.id
              }
            );
          }
        });
      }
    });
  }

  fetchsection() {
    const query: any = {};
    query.surveyId = this.surveyId;
    query.includeFlowChartsInfo = false;
    query.includeFirstFlowchart = false;
    query.includeSelectedSections = [this.section.id];
    this.flowChartDataService.getFlowChartResponseInfoByQueryObj(query).pipe(takeUntil(this.unsubscribe$)).subscribe(
      data => {
        if (data.flowchartSections && data.flowchartSections[this.section.flowchartId] && data.flowchartSections[this.section.flowchartId].length === 1) {
          this.section = data.flowchartSections[this.section.flowchartId][0];
          this.initialize();
        }
        console.log('flowchart get sections', data);

      }
      ,
      error => {
        console.error('flowchart get sections error', error);
      }
    );
  }

  closeRightSidebar() {
    if (this.sidebarService.getSidebar('rightsidebar')) {
      this.sidebarService.getSidebar('rightsidebar').close();
      this.sidebarService.getSidebar('rightsidebar').fold();
    }
    this.platformSidebarStore.dispatch(new SetCurrentRightSideComponentAction(null));
    this.platformSidebarStore.dispatch(new SetCurrentRightSideBarFoldOrNotAction(true));
  }

  openDetailsAndInstructions(node: any) {
    // this.detailsInstructionService.openDetailsInstructionPopUp(this.sourceType, node.item.fieldKey);
    const header = '<div style="margin-bottom: 20px;font-weight: bold;font-size: .95rem;">' + node.item.title + '</div>';
    this.detailsInstructionService.getDetailsInstruction(InstructionDetailsSourceViewType.flowchart, this.sourceType, node.item.fieldKey).subscribe(data => {
      if (data) {
        const viewDetailObj = {};
        viewDetailObj['notes'] = header;
        if (data.details) {
          viewDetailObj['notes'] += data.details;
        }
        if (data.attachments) {
          viewDetailObj['attachments'] = data.attachments;
        }
        this.detailsInstructionService.setViewDetail(viewDetailObj,true);
      } else {
        const detailMessage = '<p><strong>No additional details available.</strong></p>';
        const fieldDetail = header + detailMessage;
        const viewDetailObj = {};
        viewDetailObj['notes'] = fieldDetail;
        this.detailsInstructionService.setViewDetail(viewDetailObj,true);
      }
    });
  }

  private setDisplayTextOfAttachments(fieldDefinitions: any, rowItem: any) {
    for (const key in fieldDefinitions) {
      if (fieldDefinitions[key].dataType === 'Attachment') {
        if (this.rowItem.cells[key]) {
          this.rowItem.cells[key].displayText = this.rowItem.cells[key].value.FileName;
        }
      }
    }
  }
}
